import { STATUS } from '@/constants/common'
import { IShotlist } from '@/types/shotlist.interface'

type TWatchShotlist = (
	taskId: string,
	onTick: (shotlist: IShotlist) => void,
	onDone: (shotlist: IShotlist) => void
) => void

export const watchTaskUntilFinished = ({
	taskId,
	watchTask,
	clearWatch,
	onProgress,
	onFinally
}: {
	taskId: string
	watchTask: TWatchShotlist
	clearWatch: () => void
	onProgress?: (shotlist: IShotlist) => void
	onFinally?: (shotlist: IShotlist) => void
}) => {
	return new Promise<void>((resolve, reject) => {
		if (!taskId) return reject(new Error('No taskId'))

		watchTask(
			taskId,
			shotlist => {
				onProgress?.(shotlist)
			},
			shotlist => {
				clearWatch()
				onFinally?.(shotlist)

				if (shotlist.status === STATUS.FINISHED && shotlist.original) {
					resolve()
				} else {
					reject(
						new Error(`Transcription finished with status: ${shotlist.status}`)
					)
				}
			}
		)
	})
}
